import { Controller } from "stimulus";
import $ from 'jquery';
require("select2/dist/css/select2");
require("select2-bootstrap-theme/dist/select2-bootstrap");

export default class extends Controller {
  static targets = [ "usersSelect"];
  
    connect() {
      
    this.element.querySelectorAll('.select2').forEach(select => {
      $(select).select2();
      $(select).on('select2:select', (event) => {
           this.saveViaAjax(event);
         });
     
         $(select).on('select2:unselect', (event) => {
           this.saveViaAjax(event);
         });      
    });
    
  }

saveViaAjax(event) {
  event.preventDefault();

  // Get the parent row
  const row = event.currentTarget.closest('.nested-fields');

  // Grab individual fields
  const reportIdField = row.querySelector('input[name*="[report_id]"]');
  const reportTitleField = row.querySelector('input[name*="[report_title]"]');
  const usersSelect = $(row.querySelector('select[name*="[users]"]'));

  const reportId = reportIdField?.value.trim();
  const reportTitle = reportTitleField?.value.trim();
  const users = usersSelect.val();

  console.log(reportId);
  console.log(reportTitle);
  console.log(users);
  

  // Validate empty fields
  if (!reportId || !reportTitle) {
    alert("Report ID and Report Title cannot be empty.");
    usersSelect.val([]).trigger('change');
    return;
  }

  // Check for duplicate reportId across all rows
  const allReportIds = Array.from(document.querySelectorAll('input[name*="[report_id]"]'))
    .map(input => input.value.trim())
    .filter(id => id); // remove blanks

  const isDuplicate = allReportIds.filter(id => id === reportId).length > 1;

  if (isDuplicate) {
    alert("Report ID must be unique.");
    reportIdField.value = ""; // Optionally clear the field
    usersSelect.val([]).trigger('change');
    return;
  }

  // Proceed with saving
  fetch(`/manage_system_dashboards`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content
    },
    body: JSON.stringify({
      system_dashboard: {
        report_id: reportId,
        report_title: reportTitle,
        users: users
      }
    })
  });
}

delete_dashboard(event) {
  event.preventDefault()

  const button = event.currentTarget
  const dashboardId = button.dataset.dashboardId
  const row = button.closest("tr")


  fetch(`/manage_system_dashboards/destroy_study_dashboard?dashboard_id=${dashboardId}`, {
  method: "DELETE",
  headers: {
    "X-CSRF-Token": document.querySelector("meta[name='csrf-token']").content,
    "Accept": "application/json"
    }
  })
  .then(response => {
    if (response.ok) {
      row.remove();
    } else {
      alert("Failed to delete.");
    }
  });

}

}